
import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Box, ButtonBase, Grid2 } from '@mui/material';
import Container from '@mui/material/Container';
import PlayButton from './PlayButton'
import MediaDialog from './MediaDialog'

import { RunbookMedia, ProcessMedia } from './Media';

export default function Intro() {
  const [open, setOpen] = React.useState(null);
  return (
    <React.Fragment>


      <MediaDialog
        open={open}
        setOpen={setOpen}>
        {
          open === 'runbook' && <RunbookMedia />
        }
        {
          open === 'process' && <ProcessMedia />
        }
      </MediaDialog>

      <Container maxWidth="xl" sx={{ my: 5 }}>
        <Grid2 container justifyContent={'space-between'} spacing={10}>
          <Grid2 size={{ xs: 12, lg: 6 }}>
            <Typography variant='h5'>Process
              Automation
            </Typography>
            <Typography variant='body1' sx={{color:'text.secondary'}}>
              Process automation involves using technology to automate complex business processes. It includes integrating systems and software to carry out tasks that typically require human intervention, streamlining operations, and improving efficiency.
            </Typography>
            <Box
              onClick={() => { setOpen('process') }}
              sx={{ background: theme => theme.palette.secondary.light, padding: '.2rem', borderRadius: '1rem', mt: '2rem' }}>
              <ButtonBase sx={{ padding: '.5rem' }}>
                <PlayButton />
                <img alt="process automation thumbnail" src={process.env.REACT_APP_CDN + '/sys/img/callgoose_sqibs_process_automation_thumbnail.avif'} width={'100%'} height={'auto'} style={{ borderRadius: '.5rem' }} />
              </ButtonBase>
            </Box>

          </Grid2>
          <Grid2 size={{ xs: 12, lg: 6 }}>

            <Typography variant='h5'>Runbook
            Automation
            </Typography>
            <Typography variant='body1' sx={{color:'text.secondary'}}>
            Runbook automation (RBA) involves automating the steps and procedures documented in a runbook, which is a compilation of routine IT operations and procedures. RBA focuses on automating IT operations and tasks to improve reliability and efficiency.
            </Typography>
            <Box
              onClick={() => { setOpen('runbook') }}
              sx={{ background: theme => theme.palette.secondary.light, padding: '.2rem', borderRadius: '1rem', mt: '2rem' }}>
              <ButtonBase sx={{ padding: '.5rem' }}>
                <PlayButton />
                <img alt="runbook automation thumbnail"  src={process.env.REACT_APP_CDN + '/sys/img/callgoose_sqibs_runbook_automation_thumbnail.avif'} width={'100%'} height={'auto'} style={{ borderRadius: '.5rem' }} />
              </ButtonBase>
            </Box>

          </Grid2>
        </Grid2>
      </Container>
    </React.Fragment>
  );
}
